export type HasKey = {
  key: string;
};

export type GroupedAttributesWithKey = HasKey & {
  name: string;
  categories: CategorizedAttributesWithKey[];
};
export type CategorizedAttributesWithKey = HasKey & {
  name: string;
  attributes: SimpleAttributeWithKey[];
};
export type SimpleAttributeWithKey = HasKey & {
  code: string;
  description: string;
  isHiddenFilter?: boolean;
};

export class SelectAttribute {
  private isHiddenFilter?: boolean;
  private isHiddenBundle?: boolean;
  private isHiddenFullAttribute?: boolean;

  public getGroup(): string {
    return this.group;
  }

  public getCategory(): string {
    return this.category;
  }

  public getCode(): string {
    return this.code;
  }

  public getGroupKey(): string {
    return this.groupKey;
  }
  public getCategoryKey(): string {
    return this.categoryKey;
  }
  public getAttributeKey(): string {
    return this.attributeKey;
  }

  public getDescription(): string {
    return this.description;
  }

  public isIsHiddenFilter(): boolean | undefined {
    return this.isHiddenFilter;
  }

  public setIsHiddenFilter(isHiddenFilter: boolean): void {
    this.isHiddenFilter = isHiddenFilter;
  }

  public isIsHiddenBundle(): boolean | undefined {
    return this.isHiddenBundle;
  }

  public setIsHiddenBundle(isHiddenBundle: boolean): void {
    this.isHiddenBundle = isHiddenBundle;
  }

  public isIsHiddenFullAttribute(): boolean | undefined {
    return this.isHiddenFullAttribute;
  }

  public setIsHiddenFullAttribute(isHiddenFullAttribute: boolean): void {
    this.isHiddenFullAttribute = isHiddenFullAttribute;
  }
  public isHidden(): boolean {
    return !!(
      this.isIsHiddenBundle() ||
      this.isIsHiddenFilter() ||
      this.isIsHiddenFullAttribute()
    );
  }

  constructor(
    private readonly group: string,
    private readonly category: string,
    private readonly code: string,
    private readonly description: string,
    private readonly groupKey: string,
    private readonly categoryKey: string,
    private readonly attributeKey: string,
  ) {
    this.group = group;
    this.category = category;
    this.code = code;
    this.description = description;
    this.groupKey = groupKey;
    this.categoryKey = categoryKey;
    this.attributeKey = attributeKey;
  }
}
